import React from 'react';
import {NavLink} from 'react-router-dom';
import 'styles/scss/website/pages/about.scss';
import {Helmet} from "react-helmet-async";
import TemplatePage from 'website/templates/templatePage/index.js';
import TreatmentPlanBar from 'website/components/TreatmentPlanBar/index';
import CONTENTS from "./CONTENTS";
import LayoutBuilder from 'LayoutBuilder';

import PAGES from 'website/pages/pages_FULL.js'; //ADD NEW PAGES HERE
  


const {Container, Row, Column} = LayoutBuilder;
class Index extends TemplatePage {
  constructor(props) {
    super(props);
    //this.state = {...this.state,
    //};    
  }

  didMount(){
  }

  willUnmount(){
  }

  render(){
    //var {showSideMenu} = this.state;
    //console.log('this.props', this.props);
    //{CONTENT.Section6[0]}
    const CONTENT = window.GlobalUtil.dangerSetGlobalObjList(CONTENTS[window.Session.Language].CONTENT); 
    const HEADER = CONTENTS[window.Session.Language].HEADER; 
    const CleanLinks = PAGES("ENGLISH").filter(Page=>Page.ShowOnSiteMap);     
    return (
      <div className="contentPage" id="PageSitemap">
        <Helmet>
            <meta charSet="utf-8" />
            <title>{HEADER.TITLE}</title>
            <meta name="description" content={HEADER.DESCRIPTION}/>
            <link  href={`${window.location.pathname}`} />
            <link rel="canonical" href={`${HEADER.BASEURL}${window.location.pathname}`} />
            <meta name="keywords" content={HEADER.KEYWORDS} />

            {"<!-- Google / Search Engine Tags -->"}
            <meta itemprop="name" content={HEADER.TITLE} />
            <meta itemprop="description" content={HEADER.DESCRIPTION}/>
            <meta itemprop="image" content="https://Smiles.Club/SocialImage_500.jpg" />

            {/*<!-- Facebook Meta Tags -->*/}
            <meta property="og:url" content={`${HEADER.BASEURL}${window.location.pathname}`} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={HEADER.TITLE} />
            <meta property="og:description" content={HEADER.DESCRIPTION}/>
            <meta property="og:image" content="https://Smiles.Club/SocialImage_500.jpg" />

            {/*<!-- Twitter Meta Tags -->*/}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={HEADER.TITLE} />
            <meta name="twitter:description" content={HEADER.DESCRIPTION}/>
            <meta name="twitter:image" content="https://Smiles.Club/SocialImage_500.jpg" />
        </Helmet>
        <div id="Section1" className='backgroundSVG2'>
          <Container >
            <Row id="Row1" className="sectionRows title">
              <Column className="textColumn" col="12" xs="12" sm="12" md="12" lg="12" xl="12">
                {CONTENT.Section1[0]}
              </Column>
            </Row>
            <Row id="Row2" className="sectionRows">
              <Column className="d-flex" col="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <div className="siteMapList">
                  <h3 className="sitemapListTitle">Navivation</h3>
                    <div className="menu-item">
                      <NavLink 
                        className={""}
                        to={"/"}>
                          Home
                      </NavLink>
                    </div>
                  {
                    CleanLinks.map((Link, index)=>{
                      if(Link.IsBlog || Link.IsCustomLandingPage) return;
                      if(Link.Menu.includes("Footer1")){
                        return(
                          <div className="menu-item" key={index}>
                            <NavLink 
                              className={""}
                              to={Link.Paths[0]}>{Link.PageName}</NavLink>
                          </div>
                        )
                      }
                    })
                  }
                </div>
                <br/>
                <br/>
              </Column>
              <Column className="d-flex" col="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <div className="siteMapList">
                  <h3 className="sitemapListTitle">Info</h3>
                  {
                    CleanLinks.map((Link, index)=>{
                      if(Link.IsBlog || Link.IsCustomLandingPage) return;
                      if(Link.Menu.includes("Footer2")){
                        return(
                          <div className="menu-item" key={index}>
                            <NavLink 
                              className={""}
                              to={Link.Paths[0]}>{Link.PageName}</NavLink>
                          </div>
                        )
                      }
                    })
                  }
                </div>
                <br/>
                <br/>
              </Column>
              <Column className="d-flex" col="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <div className="siteMapList">
                  <h3 className="sitemapListTitle">Blog</h3>
                  {
                    CleanLinks.map((Link, index)=>{
                      if(Link.IsBlog) return(
                        <div className="menu-item" key={index}>
                          <NavLink 
                            className={""}
                            to={Link.Paths[0]}>{Link.PageName}</NavLink>
                        </div>
                      )
                    })
                  }
                </div>
                <br/>
                <br/>
              </Column>
              {/* <Column className="textColumn" col="12" xs="12" sm="12" md="12" lg="7" xl="6">
                {CONTENT.Section1[0]}
              </Column>
              <Column className="d-none d-lg-block" col="12" xs="12" sm="12" md="12" lg="5" xl="6">
                <div id="MainImage">
                  <img className="stepImages" 
                    id="StepImages3"
                    src={Selfie} 
                    alt={CONTENT.Section1[1]}
                  />
                </div>
              </Column> */}
            </Row>
          </Container>
        </div>
        <TreatmentPlanBar/>
      </div>
    );
  }
}


export default Index;
      